
import { useEffect } from "react";



const Piano = (props) => {

    let right_keys = null
    right_keys = props.correctAnswer;
    const keys = [...new Set(right_keys)];

    useEffect(() => {
        if(right_keys == null){
            for(let i=0; i<= 33; i++){
                let piano_note = document.getElementById(i);
                if (piano_note) {
                    piano_note.style.removeProperty('background');
                }
            }
        }
    })

    const piano_keys = [
        'C',
        'C#',
        'Db',
        'D',
        'D#',
        'Eb',
        'E',
        'F',
        'F#',
        'Gb',
        'G',
        'G#',
        'Ab',
        'A',
        'A#',
        'Bb',
        'B',
        'C',
        'C#',
        'Db',
        'D',
        'D#',
        'Eb',
        'E',
        'F',
        'F#',
        'Gb',
        'G',
        'G#',
        'Ab',
        'A',
        'A#',
        'Bb',
        'B'
    ];

    const tunes = {
        c: require('./assets/notes/c4.mp3'),
        w: require('./assets/notes/db4.mp3'),
        s: require('./assets/notes/d4.mp3'),
        e: require('./assets/notes/eb4.mp3'),
        d: require('./assets/notes/e4.mp3'),
        f: require('./assets/notes/f4.mp3'),
        t: require('./assets/notes/gb4.mp3'),
        g: require('./assets/notes/g4.mp3'),
        y: require('./assets/notes/ab4.mp3'),
        h: require('./assets/notes/a4.mp3'),
        u: require('./assets/notes/bb4.mp3'),
        j: require('./assets/notes/b4.mp3'),
        k: require('./assets/notes/c5.mp3'),
        o: require('./assets/notes/db5.mp3'),
        l: require('./assets/notes/d5.mp3'),
        p: require('./assets/notes/eb5.mp3'),
        a: require('./assets/notes/e5.mp3'),
        f2: require('./assets/notes/f5.mp3'),
        t2: require('./assets/notes/gb5.mp3'),
        g2: require('./assets/notes/g5.mp3'),
        y2: require('./assets/notes/ab5.mp3'),
        h2: require('./assets/notes/a5.mp3'),
        u2: require('./assets/notes/bb5.mp3'),
        j2: require('./assets/notes/b5.mp3')
    };


    const playTune = (key) => {
        const audioPath = tunes[key];

        if (audioPath) {
            const audio = new Audio(audioPath);
            audio.play();
        } else {
            console.log(`Tune for key "${key}" not found.`);
        }
    };



    const eliminating_correct_keys = (key) => {

        if (keys.length !== 0) {

            let first_index_of_correct_key = piano_keys.indexOf(right_keys[0]);


            let last_index_of_correct_key = piano_keys.lastIndexOf(right_keys[right_keys.length - 1]);

            let selected_keys = [];

            for (let i = first_index_of_correct_key; i <= last_index_of_correct_key; i++) {
                selected_keys.push(piano_keys[i]);
            }


            const firstIndex = piano_keys.indexOf(selected_keys[0]);

            if (firstIndex !== -1) {
                const endingIndex = firstIndex + selected_keys.length - 1;
                const matchingKeys = piano_keys.slice(firstIndex, endingIndex + 1);
                const matchingIndexes = matchingKeys.map((key, index) => firstIndex + index);
                const matchingObject = {};
                matchingIndexes.forEach((index, i) => {
                    matchingObject[index] = matchingKeys[i];
                });


                const matchedKeys = right_keys
                    .filter(key => Object.values(matchingObject).includes(key))
                    .map(key => {
                        const matchingIndexes = Object.keys(matchingObject).filter(index => matchingObject[index] === key);
                        return matchingIndexes;
                    })
                    .reduce((acc, indexes) => acc.concat(indexes), []);

                console.log(matchedKeys);


                matchedKeys.forEach((id) => {
                    switch(id){
                        case "2": 
                            id = "1";
                            break;
                        case "5":
                            id = "4";
                            break;
                        case "9":
                            id = "8";
                            break;
                        case "12": 
                            id = "11";
                            break;
                        case "15":
                            id = "14";
                            break;
                        case "19":
                            id = "18";
                            break;
                        case "22": 
                            id = "21";
                            break;
                        case "26":
                            id = "25";
                            break;
                        case "29":
                            id = "28";
                            break;
                        case "32":
                            id = "31";
                            break;
                    }
                    let piano_note = document.getElementById(id);
                    if (piano_note) {
                        piano_note.style.background = 'green';
                    }
                })

            } else {
                console.log("First item not found in pianoKeys.");
            }

        } else{

        }

    }


    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignContent: 'center', }} >
            <div className="wrapper">


                <ul className="piano-keys">

                    <li
                        className='key white'
                        data-key="c"
                        onClick={() => playTune("c")}
                        id="0"
                    >
                        
                        <span className={keys.find(key => key === 'C') ? `${eliminating_correct_keys(keys.find(key => key === 'C'))} ` : ''}>


                            {piano_keys[0]}

                        </span>
                    </li>

                    <li
                        className="key black"
                        data-key="w"
                        onClick={() => playTune("w")}
                        id="1"
                    >
                        <p style={{ color: "white", textAlign: 'center', marginTop: 70 }} >
                            {piano_keys[1]}
                        </p>

                        <p style={{ color: "white", textAlign: 'center' }} className={keys.find(key => key === 'C#' || key === 'Db') ? `${eliminating_correct_keys(keys.find(key => key === 'C#' || key === 'Db'))} ` : ''}>
                            {piano_keys[2]}
                        </p>


                    </li>

                    <li
                        className="key white"
                        data-key="s"
                        onClick={() => playTune("s")}
                        id="3"
                    >
                        <span className={keys.find(key => key === 'D') ? `${eliminating_correct_keys(keys.find(key => key === 'D'))} ` : ''}>

                            {piano_keys[3]}
                        </span>
                    </li>

                    <li
                        className="key black"
                        data-key="e"
                        onClick={() => playTune("e")}
                        id="4"
                    >

                        <p style={{ color: "white", textAlign: 'center', marginTop: 70 }} className={keys.find(key => key === 'C#' || key === 'Db') ? `${eliminating_correct_keys(keys.find(key => key === 'C#' || key === 'Db'))} ` : ''}>
                            {piano_keys[4]}
                        </p>

                        <p style={{ color: "white", textAlign: 'center' }} className={keys.find(key => key === 'C#' || key === 'Db') ? `${eliminating_correct_keys(keys.find(key => key === 'C#' || key === 'Db'))} ` : ''}>
                            {piano_keys[5]}
                        </p>
                    </li>

                    <li
                        className="key white"
                        data-key="d"
                        onClick={() => playTune("d")}
                        id="6"
                    >
                        <span className={keys.find(key => key === 'E') ? `${eliminating_correct_keys(keys.find(key => key === 'E'))} ` : ''}>

                            {piano_keys[6]}
                        </span>
                    </li>

                    <li id="7" className="key white" data-key="f" onClick={() => playTune("f")}>
                        <span  className={keys.find(key => key === 'F') ? `${eliminating_correct_keys(keys.find(key => key === 'F'))} ` : ''} >

                            {piano_keys[7]}
                        </span>
                    </li>

                    <li id="8" className="key black" data-key="t" onClick={() => playTune("t")}>


                        <p style={{ color: "white", textAlign: 'center', marginTop: 70 }} className={keys.find(key => key === 'C#' || key === 'Db') ? `${eliminating_correct_keys(keys.find(key => key === 'C#' || key === 'Db'))} ` : ''}>
                            {piano_keys[8]}
                        </p>

                        <p style={{ color: "white", textAlign: 'center' }} className={keys.find(key => key === 'C#' || key === 'Db') ? `${eliminating_correct_keys(keys.find(key => key === 'C#' || key === 'Db'))} ` : ''}>
                            {piano_keys[9]}
                        </p>
                    </li>

                    <li id="10" className="key white" data-key="g" onClick={() => playTune("g")}>
                        <span className={keys.find(key => key === 'G') ? `${eliminating_correct_keys(keys.find(key => key === 'G'))} ` : ''} >

                            {piano_keys[10]}
                        </span>
                    </li>


                    <li id="11" className="key black" data-key="y" onClick={() => playTune("y")}>


                        <p style={{ color: "white", textAlign: 'center', marginTop: 70 }} className={keys.find(key => key === 'C#' || key === 'Db') ? `${eliminating_correct_keys(keys.find(key => key === 'C#' || key === 'Db'))} ` : ''}>
                            {piano_keys[11]}
                        </p>

                        <p style={{ color: "white", textAlign: 'center' }} className={keys.find(key => key === 'C#' || key === 'Db') ? `${eliminating_correct_keys(keys.find(key => key === 'C#' || key === 'Db'))} ` : ''}>
                            {piano_keys[12]}
                        </p>
                    </li>

                    <li id="13" className="key white" data-key="h" onClick={() => playTune("h")}>
                        <span className={keys.find(key => key === 'A') ? `${eliminating_correct_keys(keys.find(key => key === 'A'))} ` : ''}>

                            {piano_keys[13]}
                        </span>
                    </li>

                    <li id="14" className="key black" data-key="u" onClick={() => playTune("u")}>


                        <p style={{ color: "white", textAlign: 'center', marginTop: 70 }} className={keys.find(key => key === 'C#' || key === 'Db') ? `${eliminating_correct_keys(keys.find(key => key === 'C#' || key === 'Db'))} ` : ''}>
                            {piano_keys[14]}
                        </p>

                        <p style={{ color: "white", textAlign: 'center' }} className={keys.find(key => key === 'C#' || key === 'Db') ? `${eliminating_correct_keys(keys.find(key => key === 'C#' || key === 'Db'))} ` : ''}>
                            {piano_keys[15]}
                        </p>
                    </li>

                    <li id="16" className="key white" data-key="j" onClick={() => playTune("j")}>
                        <span className={keys.find(key => key === 'B') ? `${eliminating_correct_keys(keys.find(key => key === 'B'))} ` : ''}>
                            {piano_keys[16]}
                        </span>
                    </li>

                    <li id="17" className="key white" data-key="k" onClick={() => playTune("k")}>
                        <span className={keys.find(key => key === 'C') ? `${eliminating_correct_keys(keys.find(key => key === 'C'))} ` : ''}>

                            {piano_keys[17]}
                        </span>
                    </li>

                    <li id="18" className="key black" data-key="o" onClick={() => playTune("o")}>


                        <p style={{ color: "white", textAlign: 'center', marginTop: 70 }} className={keys.find(key => key === 'C#' || key === 'Db') ? `${eliminating_correct_keys(keys.find(key => key === 'C#' || key === 'Db'))} ` : ''}>
                            {piano_keys[18]}
                        </p>

                        <p style={{ color: "white", textAlign: 'center' }} className={keys.find(key => key === 'C#' || key === 'Db') ? `${eliminating_correct_keys(keys.find(key => key === 'C#' || key === 'Db'))} ` : ''}>
                            {piano_keys[19]}
                        </p>
                    </li>

                    <li id="20" className="key white" data-key="l" onClick={() => playTune("l")}>
                        <span className={keys.find(key => key === 'D') ? `${eliminating_correct_keys(keys.find(key => key === 'D'))} ` : ''}>

                            {piano_keys[20]}
                        </span>
                    </li>

                    <li id="21" className="key black" data-key="p" onClick={() => playTune("p")}>

                        <p style={{ color: "white", textAlign: 'center', marginTop: 70 }} className={keys.find(key => key === 'C#' || key === 'Db') ? `${eliminating_correct_keys(keys.find(key => key === 'C#' || key === 'Db'))} ` : ''}>
                            {piano_keys[21]}
                        </p>

                        <p style={{ color: "white", textAlign: 'center' }} className={keys.find(key => key === 'C#' || key === 'Db') ? `${eliminating_correct_keys(keys.find(key => key === 'C#' || key === 'Db'))} ` : ''}>
                            {piano_keys[22]}
                        </p>
                    </li>

                    <li id="23" className="key white" data-key="a" onClick={() => playTune("a")}>
                        <span className={keys.find(key => key === 'E') ? `${eliminating_correct_keys(keys.find(key => key === 'B'))} ` : ''}>
                            {piano_keys[23]}
                        </span>
                    </li>


                    <li id="24" className="key white" data-key="f2" onClick={() => playTune("f2")}>
                        <span className={keys.find(key => key === 'F') ? `${eliminating_correct_keys(keys.find(key => key === 'B'))} ` : ''}>

                            {piano_keys[24]}
                        </span></li>

                    <li id="25" className="key black" data-key="t2" onClick={() => playTune("t2")}>

                        <p style={{ color: "white", textAlign: 'center', marginTop: 70 }} className={keys.find(key => key === 'C#' || key === 'Db') ? `${eliminating_correct_keys(keys.find(key => key === 'C#' || key === 'Db'))} ` : ''}>
                            {piano_keys[25]}
                        </p>

                        <p style={{ color: "white", textAlign: 'center' }} className={keys.find(key => key === 'C#' || key === 'Db') ? `${eliminating_correct_keys(keys.find(key => key === 'C#' || key === 'Db'))} ` : ''}>
                            {piano_keys[26]}
                        </p>
                    </li>

                    <li id="27" className="key white" data-key="g2" onClick={() => playTune("g2")}>
                        <span className={keys.find(key => key === 'G') ? `${eliminating_correct_keys(keys.find(key => key === 'B'))} ` : ''}>

                            {piano_keys[27]}
                        </span>
                    </li>

                    <li id="28" className="key black" data-key="y2" onClick={() => playTune("y2")}>

                        <p style={{ color: "white", textAlign: 'center', marginTop: 70 }} className={keys.find(key => key === 'C#' || key === 'Db') ? `${eliminating_correct_keys(keys.find(key => key === 'C#' || key === 'Db'))} ` : ''}>
                            {piano_keys[28]}
                        </p>

                        <p style={{ color: "white", textAlign: 'center' }} className={keys.find(key => key === 'C#' || key === 'Db') ? `${eliminating_correct_keys(keys.find(key => key === 'C#' || key === 'Db'))} ` : ''}>
                            {piano_keys[29]}
                        </p>
                    </li>

                    <li id="30" className="key white" data-key="h2" onClick={() => playTune("h2")}>
                        <span className={keys.find(key => key === 'A') ? `${eliminating_correct_keys(keys.find(key => key === 'B'))} ` : ''}>

                            {piano_keys[30]}
                        </span></li>

                    <li id="31" className="key black" data-key="u2" onClick={() => playTune("u2")}>


                        <p style={{ color: "white", textAlign: 'center', marginTop: 70 }} className={keys.find(key => key === 'C#' || key === 'Db') ? `${eliminating_correct_keys(keys.find(key => key === 'C#' || key === 'Db'))} ` : ''}>
                            {piano_keys[31]}
                        </p>

                        <p style={{ color: "white", textAlign: 'center' }} className={keys.find(key => key === 'C#' || key === 'Db') ? `${eliminating_correct_keys(keys.find(key => key === 'C#' || key === 'Db'))} ` : ''}>
                            {piano_keys[32]}
                        </p>
                    </li>

                    <li id="33" className="key white" data-key="j2" onClick={() => playTune("j2")}>
                        <span className={keys.find(key => key === 'B') ? `${eliminating_correct_keys(keys.find(key => key === 'B'))} ` : ''}>

                            {piano_keys[33]}
                        </span></li>
                </ul>
            </div>
        </div>
    );
};

export default Piano;